import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import 'slick-carousel';

$(document).ready(() => {
    $('.hero2__step').on('click', function () {
        const $this = $(this);
        const $content = $this.find('.hero2__step-content');
        $this.prevAll().removeClass('active').find('.hero2__step-content').removeAttr('style');
        $this.nextAll().removeClass('active').find('.hero2__step-content').removeAttr('style');
        $this.toggleClass('active');
        if ($this.hasClass('active')) {
            $content.css('height', $content[0].scrollHeight).css('opacity', '1');
        } else {
            $content.removeAttr('style');
        }
    });
    $('.it__item').on('click', function () {
        const $this = $(this);
        const $content = $this.find('.it__item-content');
        $this.prevAll().removeClass('active').find('.it__item-content').removeAttr('style');
        $this.nextAll().removeClass('active').find('.it__item-content').removeAttr('style');
        $this.toggleClass('active');
        if ($this.hasClass('active')) {
            $content.css('height', $content[0].scrollHeight).css('opacity', '1');
        } else {
            $content.removeAttr('style');
        }
    });
    $('.steps__list').slick({
        arrows: true,
        prevArrow: $('.steps__arrow-left'),
        nextArrow: $('.steps__arrow-right'),
        infinite: false,
        slidesToShow: 3,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '20%',
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '32px',
                }
            }, {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '0',
                }
            }
        ]
    });
    $('.specs__slider').slick({
        arrows: true,
        prevArrow: $('.specs__arrow-left'),
        nextArrow: $('.specs__arrow-right'),
        infinite: false,
        slidesToShow: 3,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
    $('.hero__icon--down').on('click', () => {
        $('html, body').animate({
            scrollTop: $(".hero2").offset().top - 120
        }, 1000);
    });
    $('[href="#wycena"]').on('click', () => {
        $('#popup').addClass('active');
    })
    $('.popup__close, .popup__bg').on('click', () => {
        $('#popup').removeClass('active');
    });
    $('.header__hamburger button').on('click', function () {
        const $this = $(this);
        $this.toggleClass('active');
        $('.menu.menu-parent-1').toggleClass('active');
    });
    $(window).on('scroll', () => {
        let $e = $(document.elementFromPoint($(window).width() / 2, $(window).height() / 2));
        let $s;
        if ($e.is('section') && $e.attr('id')) {
            $s = $e;
        } else {
            $s = $e.parents('section');
        }
        $('.menu__link.active').removeClass('active');
        $('.menu__link[href="#' + $s.attr('id') + '"]').addClass('active');
    });
    $(window).trigger('scroll');
});